import PageContainer from "@/components/react/PageContainer";
import QRCode from "react-qr-code";
import { css } from "@styled-system/css";
import { Box } from "@styled-system/jsx";
import useI18n from "@/hooks/useI18n";
import { useEffect, useState } from "react";
import Spinner from "@/components/react/Spinner";

export default function OpenOnMobile() {
  const [path, setPath] = useState("");
  const { t } = useI18n();

  useEffect(() => {
    setPath(window.location.href);
  }, []);

  // prevents server render error
  const QRCodeComponent = ((QRCode as any).default || QRCode) as typeof QRCode;
  return (
    <PageContainer image="pair.svg" title={t("openOnMobile.title")}>
      {path ? (
        <>
          <p className={css({ textAlign: "center", textStyle: "subheader" })}>{path}</p>
          <Box className={css({ mt: "3.25rem", mb: "5rem" })}>
            <QRCodeComponent value={path} size={100} />
          </Box>
        </>
      ) : (
        <Spinner className={css({ mb: "5rem" })} />
      )}
    </PageContainer>
  );
}
